export enum PieceType {
  UNIT = "u",
  LARGE = "l",
  LONG = "o",
  SQUARE = "s",
}
